import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useRegisterSW } from "virtual:pwa-register/react"

import { toaster } from "@/components/feedback/Toast"

/**
 * PWA güncelleme bildirimi (ADR #038).
 *
 * `registerType: "prompt"` modunda yeni deploy'un service worker'ı arka planda
 * indirilir ama açık sekme eski bundle'la çalışmaya devam eder. Bu bileşen yeni
 * sürüm hazır olduğunda kalıcı bir toast gösterir; "Yenile"ye basılınca yeni
 * SW aktive edilip sayfa yeniden yüklenir. Uzun ömürlü sekmeler deploy'u hiç
 * fark edemeyeceği için periyodik update kontrolü de yapılır.
 *
 * Dev'de vite-plugin-pwa virtual modülü no-op — bileşen hiçbir şey yapmaz.
 */
const UPDATE_CHECK_MS = 15 * 60_000
const TOAST_ID = "pwa-update"

export function PwaUpdatePrompt() {
  const { t } = useTranslation("common")
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      if (registration) {
        setInterval(() => {
          void registration.update()
        }, UPDATE_CHECK_MS)
      }
    },
  })

  useEffect(() => {
    if (!needRefresh || toaster.isVisible(TOAST_ID)) {
      return
    }
    toaster.create({
      id: TOAST_ID,
      title: t("pwa.updateReady"),
      description: t("pwa.updateDescription"),
      type: "info",
      duration: Number.POSITIVE_INFINITY,
      action: {
        label: t("pwa.reload"),
        onClick: () => {
          void updateServiceWorker(true)
        },
      },
    })
  }, [needRefresh, t, updateServiceWorker])

  return null
}
